<template>
    <div>
        <van-collapse v-model="activate" @change="collapseChange">
            <van-collapse-item title="借款信息">

              <div class="">
                <van-divider>申请信息</van-divider>
                <van-field
                        clearable
                        label="产品名称"
                        label-width="120px"
                        input-align="left"
                        :value="applyInfo.productInstanceName"
                        readonly
                />
                  <van-field
                        clearable
                        label="借款用途"
                        label-width="120px"
                        input-align="left"
                        :value="applyInfo.borrowPurpose"
                        readonly
                />
                <van-field
                        clearable
                        label="申请金额"
                        label-width="120px"
                        input-align="left"
                        :value="applyInfo.borrowAmount | amountFormat(' 元')"
                        readonly
                />
                <van-field
                    clearable
                    label="借款期限"
                    label-width="120px"
                    input-align="left"
                    :value = "applyInfo.borrowTerm + ' 月'"
                    readonly
                />
                <van-field
                    clearable
                    label="还款方式"
                    label-width="120px"
                    input-align="left"
                    :value="applyInfo.repayModeCn"
                    readonly
                />
                <van-field
                    clearable
                    label="银行贷款余额"
                    label-width="120px"
                    :value="applyInfo.bankLoanBalance | amountFormat('元')"
                    readonly
                />
                <van-field
                    clearable
                    label="借款描述"
                    type="textarea"
                    label-width="120px"
                    :value="applyInfo.remark"
                    autosize
                    readonly
                />
              </div>
              <div class="">
                <van-divider>审批信息</van-divider>
              <van-field
                  clearable
                  label="批准金额"
                  placeholder="请输入借款期限"
                  label-width="120px"
                  input-align="left"
                  :value="applyInfo.approveAmt | amountFormat(' 元')"
                  readonly
              />

                <van-field
                        v-if="applyInfo.approveNo"
                        clearable
                        label="批贷期限"
                        label-width="120px"
                        input-align="left"
                        :value = "applyInfo.approveNo + ' 月'"
                        readonly
                />

                <van-field
                    clearable
                    label="综合抵押率"
                    label-width="120px"
                    input-align="left"
                    :value = "(applyInfo.mortgageRateConvert||0) + ' %'"
                    readonly
                />
                <van-field
                    clearable
                    label="批准年利率"
                    label-width="120px"
                    input-align="left"
                    :value="applyInfo.approveRate | numNull('%')"
                    readonly
                />
                <van-field
                    clearable
                    label="上浮利率"
                    label-width="120px"
                    input-align="left"
                    :value="(applyInfo.floatRate||0) | numNull('%')"
                    readonly
                />

                <van-col offset="1" span="23" v-if="show">
                  <van-field
                             clearable
                             label="销售结算利率"
                             label-width="120px"
                             input-align="left"
                             :value="(applyInfo.nominalRate||0) | numNull('%')"
                             readonly
                  />

                </van-col>
                <van-field
                    clearable
                    label="业务单元"
                    readonly
                    label-width="120px"
                    :value="department"
                />
              <van-field
                  clearable
                  label="业务类型"
                  readonly
                  label-width="120px"
                  :value="company.subType | subTypeFormat"
                />
                <van-field
                        clearable
                        label="业务来源"
                        label-width="120px"
                        input-align="left"
                        :value="company.companyCnname"
                        readonly
                />

                <van-field  v-if="applyInfo.fundingFlag!=''&&applyInfo.fundingFlag!=null"
                        clearable
                        label="渠道配资"
                        label-width="120px"
                        :value="applyInfo.fundingFlag"
                        readonly
                />
                <van-field v-if="applyInfo.fundingFlag=='是'"
                        clearable
                        label="配资金额"
                        label-width="120px"
                        :value="applyInfo.fundingAmount | amountFormat('元')"
                        readonly
                />
              </div>
            </van-collapse-item>

            <van-collapse-item title="个人信息">
                <van-field
                        clearable
                        label="借款人"
                        label-width="120px"
                        :value="customer.customerName"
                        readonly
                />
                <van-field
                        clearable
                        label="出生日期"
                        label-width="120px"
                        :value="customer.customerBirthday | dateYmdFormat"
                        readonly
                />
                <van-field
                        clearable
                        label="性别"
                        label-width="120px"
                        :value="customer.customerGender == '1' ? '男':'女'"
                        readonly
                />
                <van-field
                        clearable
                        type="textarea"
                        label-width="120px"
                        autosize
                        readonly
                        :value="customerDetail.userAddressProvice + customerDetail.userAddressCity + ',' + customerDetail.userAddress"
                        label="现居地址"
                />
                <van-field
                        clearable
                        type="text"
                        label-width="120px"
                        autosize
                        :value="customerDetail.customerMaritalStatusCN"
                        label="婚姻情况"
                        readonly
                />
                <van-field
                        clearable
                        type="text"
                        label-width="120px"
                        autosize
                        :value="customerDetail.userIncome | amountFormat('元')"
                        label="家庭年收入"
                        readonly
                />

                <van-field
                        clearable
                        type="text"
                        label-width="120px"
                        autosize
                        label="共借人"
                        :value="applyInfo.commonCustomer"
                        readonly
                />
            </van-collapse-item>

            <van-collapse-item title="抵押物信息">
                <van-field
                        clearable
                        type="text"
                        label="产权人"
                        :value="house.propertyPerson"
                        readonly
                />
                <van-field
                        clearable
                        type="text"
                        label="产权证号"
                        :value="house.propertyCardNumber"
                        readonly
                />
                <van-field
                        clearable
                        type="text"
                        readonly
                        :value="house.houseArea"
                        label="面积(㎡)"
                />
                <van-field
                        clearable
                        type="text"初审意见
                        readonly
                        :value="house.finalPrice"
                        label="参考价(万)"
                />
                <van-field
                        clearable
                        type="text"
                        readonly
                        :value="house.estateName"
                        label="小区名称"
                />
                <van-field
                        clearable
                        type="text"
                        readonly
                        :value="house.realestateTypeCN"
                        label="房产类型"
                />
                <van-field
                        clearable
                        type="textarea"
                        autosize
                        readonly
                        :value="house.province + house.city + house.district + house.detailedAdress"
                        label="房产地址"
                />
            </van-collapse-item>

            <van-collapse-item title="客户银行信息">
                <van-field
                        clearable
                        label="开户姓名"
                        :value="bank.accountName"
                        readonly
                />
                <van-field
                        clearable
                        label="银行卡号"
                        :value="bank.bankAccount"
                        readonly
                />
                <van-field
                        clearable
                        label="银行名称"
                        :value="bank.cnBankName"
                        readonly
                />
                <van-field
                        clearable
                        label="开户行"
                        :value="bank.customerBankProvince + bank.customerBankCity + bank.accountBankName"
                        readonly
                />
            </van-collapse-item>

            <van-collapse-item title="客户银行信息" v-if="bank1Show">
                <van-field
                        clearable
                        label="开户姓名"
                        :value="bank1.accountName"
                        readonly
                />
                <van-field
                        clearable
                        label="银行卡号"
                        :value="bank1.bankAccount"
                        readonly
                />
                <van-field
                        clearable
                        label="银行名称"
                        :value="bank1.cnBankName"
                        readonly
                />
                <van-field
                        clearable
                        label="开户行"
                        :value="bank1.customerBankProvince + bank1.customerBankCity + bank1.accountBankName"
                        readonly
                />
            </van-collapse-item>

        </van-collapse>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { AUDIT_STATUS, APPLY_INFO,HOUSE_INFO } from '@/vue/store/mutation-type'
    import { getApplyInfo } from '@/api/loanInfo'
    import {eventBus} from '@/vue/utils/eventBus'
    import { mapGetters } from 'vuex'
    import store from '@/vue/store'

    export default {
        name: 'loan-info',
        props: {
            applyId: {
                type: String,
                default: ''
            }
        },
        computed: mapGetters([
            'token'
        ]),
        data() {
            return {
                show:true,
                activate: [],
                applyInfo: {
                  mortgageRateConvert: ''
                },
                customer: {},
                customerDetail: {},
                department:'',  //业务单元
                company:{
                  companyName:'',
                  subType:'',
                },
                bank: {
                    accountName: '',
                    bankAccount: '',
                    cnBankName: '',
                    customerBankProvince: '',
                    customerBankCity: '',
                    accountBankName: ''
                },
                bank1: {
                    accountName: '',
                    bankAccount: '',
                    cnBankName: '',
                    customerBankProvince: '',
                    customerBankCity: '',
                    accountBankName: ''
                },
                bank1Show:false,
                applyBanks: [],
                house: {},
            }
        },
        mounted() {
            this.loadData()
        },
        methods: {
            collapseChange(array) {
            },
            handleArrow(){
              this.show=!this.show
            },
            credit(boolean){
                let url = this.baseUrl + '/creditReport/wapInfo?applyId=7c507273143d46a48366692be3cd6a72&refresh=' + boolean
                window.open(url,'_blank')
            },
            loadData() {
                let self = this
                getApplyInfo({applyId: this.applyId}).then(res => {
                    if (res.success) {
                        self.applyInfo = res.applyInfo
                        if(!self.applyInfo.mortgageRateConvert){
                          self.applyInfo.mortgageRateConvert = ''
                        }
                        self.customer = res.customer
                        self.customerDetail = res.customerDetail
                        self.house = res.house
                        self.company=res.company
                        self.department=res.department
                        if(typeof(res.bank) != "undefined"){
                            if(res.bank.length>0)
                                self.bank = res.bank[0]
                            if(res.bank.length>1){
                                self.bank1 = res.bank[1]
                                self.bank1Show =true
                            }
                        }
                        //处理当前进件状态
                        let expire = 7 * 24 * 60 * 60 * 1000
                        Vue.ls.set(AUDIT_STATUS, self.applyInfo.auditStatus, expire)
                        Vue.ls.set(APPLY_INFO, self.applyInfo, expire)
                        Vue.ls.set(HOUSE_INFO, self.house, expire)
                        store.commit('SET_AUDIT_STATUS', Vue.ls.get(AUDIT_STATUS))
                        store.commit('SET_APPLY_INFO', Vue.ls.get(APPLY_INFO))
                        eventBus.$emit('auditStatus',self.applyInfo.auditStatus)
                    }
                })
            }
        }
    }
</script>

<style scoped>


</style>
